import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaPageComponent from "~/modules/app/components/GaiaPageComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";
import LanguagePicker from "~/modules/app/components/LanguagePicker";
import useCurrentUser from "~/modules/auth/hooks/useCurrentUser";
import useLogout from "~/modules/auth/hooks/useLogout";

import PasswordUpdateForm from "../components/PasswordUpdateForm";
import UserProfileUpdateForm from "../components/UserProfileUpdateForm";

export function UserProfileScreenBreadcrumb() {
    const user = useCurrentUser();
    if (!user?.firstName || !user?.lastName) return `Profile`;
    return `${user.firstName} ${user.lastName}`;
}

export default function UserProfileScreen() {
    const user = useCurrentUser();
    const { logout } = useLogout();
    const { t } = useTranslation("user");

    if (!user) throw Error("No User found");

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageComponent title={user ? `${user.firstName} ${user.lastName}` : ""}>
                <UserProfileUpdateForm user={user} />
            </GaiaPageComponent>

            <GaiaPageComponent title={t("userForm.language")}>
                <LanguagePicker />
            </GaiaPageComponent>

            <GaiaPageComponent title={t("userForm.labelPassword")}>
                <PasswordUpdateForm user={user} />
            </GaiaPageComponent>

            <GaiaPageComponent sx={{ textAlign: "center" }}>
                <Button sx={{ mt: 3 }} variant="text" onClick={logout}>
                    {t("userForm.btnLogout")}
                </Button>
            </GaiaPageComponent>
        </GaiaPageLayoutColumn>
    );
}
